<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
            <div class="container">
                <a class="navbar-brand js-scroll-trigger"  href="#" onclick="$('html,body').scrollTop(0); return false">ROWERON</a><button class="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">Menu<i class="fas fa-bars ml-1"></i></button>
                <!-- <a class="navbar-brand js-scroll-trigger" href="#page-top">RowerUp live</a><button class="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">Menu<i class="fas fa-bars ml-1"></i></button> -->
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav text-uppercase ml-auto">

                        <!-- Anchor works pay attention that cobtact us is becoming green button - turn off it. Green Button works just for PORTAL-->
                        <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#testimonials">About us</a></li>
                        <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#contact">Get in touch</a></li>

                        <!-- <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#testimonials"></a></li> -->
                        <!-- Start works just for NOT logged user -->
                        <!-- <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#team">Pre-register</a></li> -->
                        <!-- <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#team">Request a free trial</a></li> -->
                        <!-- <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#team">Sign Up</a></li>
                        <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#team">Sign In</a></li> -->

                        <!-- Finish Start works just for NOT logged user -->

                        <!-- Start works just for logged user -->
                        <!-- <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#team">Sing OUT</a></li> -->
                        <!-- <li class="nav-item mx-0 mx-lg-1"><a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#main">Portal</a></li> -->
                        <!-- Finish Start works just for logged user Button PORTAL IS GREEEN ALWAYS-->

                    </ul>
                </div>
            </div>
        </nav>
        <!-- Masthead-->
        <header class="masthead" id="main">
            <div class="container">

                <div class="masthead-subheading"></div>
                <h6 class="section-heading"></h6>
                <h1 class="section-heading">Turn any rower <div class="masthead-subheading"></div>into a smart rower</h1>
                <div class="masthead-subheading"></div>
                <h5 class="section-heading ">Roweron upgrades any rower with a 24-inch touchscreen display for streamed workouts from real coaches and AI-powered Real-Time Form Feedback.</h5>
                <div class="masthead-subheading"></div>
                <div class="masthead-subheading text-uppercase"></div>
                <a class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="#contact">Pre-order now</a>

            </div>
        </header>

        <!-- <h5 class="section-heading "><br>RowerupLive boosts your rower into smart, provides workouts from the real coaches on a 24" display.  <br> Your workout is combined with Real-Time Form Feedback based on AI vision.  </h5> -->
        <!-- <h5 class="section-heading ">RowerupLive equips any simple rower with a 24" display and provides workouts from the real coaches combined with Real-Time Form Feedback based on AI vision. We make the rowing experience to be immersive.</h5> -->
        <!-- <h5 class="section-heading ">Roweron turns any rower into a connected rower by streaming workouts from real coaches on a 24" touchscreen combined with Real-Time Form Feedback.</h5> -->
        <!-- <h5 class="section-heading "><br>RowerUp Live upgrades your rower into smart and provides workouts from the best coaches on a 24" touchscreen. Your workout is combined with Real-Time Form Feedback based on our team's Computer Vision experience with the rowerup.com project<h5> -->
        <!-- <h1 class="section-heading text-uppercase">Make your rowing workout fun and healthy by workout classes from the best athletes and Real-Time Form Feedback on a Peloton-like display</h1> -->
        <!-- <h5 class="section-heading">Make your rowing workout fun and healthy by workout classes from the best athletes and Real-Time Form Feedback on a Peloton-like display</h5> -->



        <!-- <div class="overlay"></div>
        <div class="embed-responsive embed-responsive-16by9">

        <video playsinline="playsinline" autoplay="autoplay" loop="loop" controls controlslist="nodownload" poster="assets/mp4/bg-video_moment.jpg">
          <source src="assets/mp4/bg-video.m4v" type="video/mp4" preload="auto">
        </video>
        </div> -->
        <!-- <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" controls controlslist="nodownload" poster="assets/mp4/bg-video_moment.jpg"> -->




        <header class="masthead2" id="main2">
            <div class="container">
                <!-- <h5 class="section-heading text-uppercase">Upgrade a dumb rower into a smart Connected Fitness machine by computer vision</h5> -->
                <div class="masthead-subheading"></div>
                <h6 class="section-heading"></h6>
                <h1 class="section-heading">AI guides & controls your form in real-time  <div class="masthead-subheading"><br></div> on easily mounted multitouch console</h1>
                <div class="masthead-subheading"></div>
                <!-- <h5 class="section-heading ">Roweron upgrades any rower with a 24" touchscreen combined with streamed workouts from real coaches and Real-Time Form Feedback.</h5> -->
                <div class="masthead-subheading"></div>
                <div class="masthead-subheading text-uppercase"></div>
                <!-- <a class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="#services">Pre-order now</a> -->

            </div>
        </header>

        <div class="embed-responsive embed-responsive-16by9">
            <!-- <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" controls controlslist="nodownload" poster="assets/mp4/bg-video_moment.jpg"> -->
            <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" controls controlslist="nodownload" poster="../assets/main2-page-assets/img/bg7-video_moment.jpg">
                <source src="../assets/main2-page-assets/mp4/bg7-video-2.mp4" type="video/mp4" preload="auto">
            </video>

            <div id="videoMessage3" class="styling">
                <!-- <h5 class="section-heading">AI vision combined with streamed workouts on a 24" display</h5> -->
                <h5 class="section-heading">Streamed workouts with AI Vision feedback on a 24" display</h5>
                <!-- <p class="videoClick">
                    <a href="portfolio.php">Check our rates</a>
                </p> -->
            </div>
        </div>





        <div class="overlay"></div>
        <div class="embed-responsive embed-responsive-16by9">
            <!-- <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" controls controlslist="nodownload" poster="assets/mp4/bg-video_moment.jpg"> -->
            <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" controls controlslist="nodownload" poster="../assets/main2-page-assets/img/bg-video_moment_21.jpg">
                <source src="../assets/main2-page-assets/mp4/bg2-video.mp4" type="video/mp4" preload="auto">
            </video>

            <div id="videoMessage2" class="styling">
                <h2 class="section-heading">The best professional coaches will engage you during the workout</h2>
                <!-- <p class="videoClick">
                    <a href="portfolio.php">Check our rates</a>
                </p> -->
            </div>
        </div>


        <!-- <header class="masthead3" id="main">
            <div class="container">

                <h2 class="section-heading"><br>Built-in AI trainer inspired by Olympians' technique</h2>
                <br>
                <br>
                <div class="masthead-subheading"></div>

              \
                <h2 class="section-heading ">guides and controls your form in real-time</h2>
                <br>

                <div class="masthead-subheading"></div>
                <div class="masthead-subheading"></div>


            </div>
        </header> -->


        <!-- <header class="masthead4" id="testimonials">
            <div class="container">

                <h1 class="section-heading">OUR EXPERIENCE</h1>
                <h2 class="section-heading">Our team has created the world's most advanced Rowing Technique Analysis Platform for coaches and athletes - <a href="https://rowerup.com">ROWERUP.COM</a>. Based on this experience and the rowing community that supports us we created  <a href="https://roweron.com">ROWERON.COM</a></h2>

                <div class="masthead-subheading"></div>

                <div class="masthead-subheading"></div>

            </div>
        </header> -->

        <header class="masthead31" id="main31">
            <div class="container">
                <!-- <h5 class="section-heading text-uppercase">Upgrade a dumb rower into a smart Connected Fitness machine by computer vision</h5> -->
                <div class="masthead-subheading"></div>
                <h6 class="section-heading"></h6>
                <h1 class="section-heading" style="width: 103%;">Smart upgrade serves all your family</h1>
                <div class="masthead-subheading"></div>
                 <h5 class="section-heading ">Streamed workouts for Yoga & Pilates that complement a rowing session.</h5>
                <div class="masthead-subheading"></div>
                <div class="masthead-subheading text-uppercase"></div>
                <!-- <a class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="#services">Pre-order now</a> -->

            </div>
        </header>



        <header class="masthead4" id="testimonials">
            <div class="container">
                <!-- <h5 class="section-heading text-uppercase">Upgrade a dumb rower into a smart Connected Fitness machine by computer vision</h5> -->
                <div class="masthead-subheading"></div>
                <h6 class="section-heading"></h6>
                <h1 class="section-heading">From the makers of <a href="https://rowerup.com">rowerup.com</a></h1>
                <div class="masthead-subheading"></div>
                <h5 class="section-heading ">Roweron was developed with the same team that created the world's most advanced Rowing Technique Analysis Platform for coaches and athletes.</h5>
                <div class="masthead-subheading"></div>
                <div class="masthead-subheading text-uppercase"></div>
                <!-- <a class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="#services">Pre-order now</a> -->

            </div>
        </header>



        <!-- About-->


        <!-- Services-->
        <!-- <section class="page-section" id="services">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Services</h2>
                    <h3 class="section-subheading text-muted">Lorem ipsum dolor sit amet consectetur.</h3>
                </div>
                <div
                 class="row text-center">
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x"><i class="fas fa-circle fa-stack-2x text-primary"></i><i class="fas fa-shopping-cart fa-stack-1x fa-inverse"></i></span>
                        <h4 class="my-3">E-Commerce</h4>
                        <p class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima maxime quam architecto quo inventore harum ex magni, dicta impedit.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x"><i class="fas fa-circle fa-stack-2x text-primary"></i><i class="fas fa-laptop fa-stack-1x fa-inverse"></i></span>
                        <h4 class="my-3">Responsive Design</h4>
                        <p class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima maxime quam architecto quo inventore harum ex magni, dicta impedit.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x"><i class="fas fa-circle fa-stack-2x text-primary"></i><i class="fas fa-lock fa-stack-1x fa-inverse"></i></span>
                        <h4 class="my-3">Web Security</h4>
                        <p class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima maxime quam architecto quo inventore harum ex magni, dicta impedit.</p>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- Portfolio Grid-->
        <!-- <section class="page-section bg-light" id="portfolio">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Portfolio</h2>
                    <h3 class="section-subheading text-muted">Lorem ipsum dolor sit amet consectetur.</h3>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-sm-6 mb-4">
                        <div class="portfolio-item">
                            <a class="portfolio-link" data-toggle="modal" href="#portfolioModal1"
                                ><div class="portfolio-hover">
                                    <div class="portfolio-hover-content"><i class="fas fa-plus fa-3x"></i></div>
                                </div>
                                <img class="img-fluid" src="assets/img/portfolio/01-thumbnail.jpg" alt=""
                            /></a>
                            <div class="portfolio-caption">
                                <div class="portfolio-caption-heading">Threads</div>
                                <div class="portfolio-caption-subheading text-muted">Illustration</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 mb-4">
                        <div class="portfolio-item">
                            <a class="portfolio-link" data-toggle="modal" href="#portfolioModal2"
                                ><div class="portfolio-hover">
                                    <div class="portfolio-hover-content"><i class="fas fa-plus fa-3x"></i></div>
                                </div>
                                <img class="img-fluid" src="assets/img/portfolio/02-thumbnail.jpg" alt=""
                            /></a>
                            <div class="portfolio-caption">
                                <div class="portfolio-caption-heading">Explore</div>
                                <div class="portfolio-caption-subheading text-muted">Graphic Design</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 mb-4">
                        <div class="portfolio-item">
                            <a class="portfolio-link" data-toggle="modal" href="#portfolioModal3"
                                ><div class="portfolio-hover">
                                    <div class="portfolio-hover-content"><i class="fas fa-plus fa-3x"></i></div>
                                </div>
                                <img class="img-fluid" src="assets/img/portfolio/03-thumbnail.jpg" alt=""
                            /></a>
                            <div class="portfolio-caption">
                                <div class="portfolio-caption-heading">Finish</div>
                                <div class="portfolio-caption-subheading text-muted">Identity</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 mb-4 mb-lg-0">
                        <div class="portfolio-item">
                            <a class="portfolio-link" data-toggle="modal" href="#portfolioModal4"
                                ><div class="portfolio-hover">
                                    <div class="portfolio-hover-content"><i class="fas fa-plus fa-3x"></i></div>
                                </div>
                                <img class="img-fluid" src="assets/img/portfolio/04-thumbnail.jpg" alt=""
                            /></a>
                            <div class="portfolio-caption">
                                <div class="portfolio-caption-heading">Lines</div>
                                <div class="portfolio-caption-subheading text-muted">Branding</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 mb-4 mb-sm-0">
                        <div class="portfolio-item">
                            <a class="portfolio-link" data-toggle="modal" href="#portfolioModal5"
                                ><div class="portfolio-hover">
                                    <div class="portfolio-hover-content"><i class="fas fa-plus fa-3x"></i></div>
                                </div>
                                <img class="img-fluid" src="assets/img/portfolio/05-thumbnail.jpg" alt=""
                            /></a>
                            <div class="portfolio-caption">
                                <div class="portfolio-caption-heading">Southwest</div>
                                <div class="portfolio-caption-subheading text-muted">Website Design</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="portfolio-item">
                            <a class="portfolio-link" data-toggle="modal" href="#portfolioModal6"
                                ><div class="portfolio-hover">
                                    <div class="portfolio-hover-content"><i class="fas fa-plus fa-3x"></i></div>
                                </div>
                                <img class="img-fluid" src="assets/img/portfolio/06-thumbnail.jpg" alt=""
                            /></a>
                            <div class="portfolio-caption">
                                <div class="portfolio-caption-heading">Window</div>
                                <div class="portfolio-caption-subheading text-muted">Photography</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- Team-->

        <!-- Clients-->
        <!-- <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-6 my-3">
                        <a href="#!"><img class="img-fluid d-block mx-auto" src="assets/img/logos/envato.jpg" alt="" /></a>
                    </div>
                    <div class="col-md-3 col-sm-6 my-3">
                        <a href="#!"><img class="img-fluid d-block mx-auto" src="assets/img/logos/designmodo.jpg" alt="" /></a>
                    </div>
                    <div class="col-md-3 col-sm-6 my-3">
                        <a href="#!"><img class="img-fluid d-block mx-auto" src="assets/img/logos/themeforest.jpg" alt="" /></a>
                    </div>
                    <div class="col-md-3 col-sm-6 my-3">
                        <a href="#!"><img class="img-fluid d-block mx-auto" src="assets/img/logos/creative-market.jpg" alt="" /></a>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- Contact-->

        <section class="page-section" id="contact">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Contact Us</h2>
                    <h3 class="section-subheading text-muted"></h3>
                </div>
                <form id="contactForm" @submit.prevent="onSubmit">
                    <div class="row align-items-stretch mb-5">
                        <div class="col-md-6">
                            <div class="form-group">
                                <input class="form-control" id="email" type="email" placeholder="Your Email" required
                                       v-model="contactUsForm.email"/>
                                <p class="help-block text-danger"></p>
                            </div>
                            <div class="form-group">
                                <input class="form-control" id="name" type="text" placeholder="Your Name"  required
                                       v-model="contactUsForm.name"/>
                                <p class="help-block text-danger"></p>
                            </div>
                            <div class="form-group mb-md-0">
                                <input class="form-control" id="occupation" type="text" placeholder="Phone number (optional)"
                                       v-model="contactUsForm.occupation"/>
                                <p class="help-block text-danger"></p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-textarea mb-md-0">
                                <textarea class="form-control" id="message" placeholder="Your Message" required
                                          v-model="contactUsForm.message"></textarea>
                                <p class="help-block text-danger"></p>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <transition name="fade">
                            <div v-if="contactUsEmailWasSent" id="success">
                                <div class='alert alert-success'><strong>Your message has been sent. Thank you.</strong></div>
                            </div>
                        </transition>
                        <FormErrors :errors="errors" style="font-weight: bold; font-size: 1.53125rem"/>
                        <button class="btn btn-primary btn-xl text-uppercase" id="sendMessageButton" type="submit">Send Message</button>
                    </div>
                </form>
            </div>
        </section>
        <!-- Footer-->
        <footer class="footer py-4">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-4 text-lg-left">Copyright © Roweron.com 2022</div>
                    <div class="col-lg-4 my-3 my-lg-0">
                        <!-- <a class="btn btn-dark btn-social mx-2" href="#!"><i class="fab fa-twitter"></i></a><a class="btn btn-dark btn-social mx-2" href="#!"><i class="fab fa-facebook-f"></i></a><a class="btn btn-dark btn-social mx-2" href="#!"><i class="fab fa-linkedin-in"></i></a> -->
                    </div>
                    <div class="col-lg-4 text-lg-right"><a class="mr-3" href="mailto:info@roweron.com">info@roweron.com</a></div>
                </div>
            </div>
        </footer>
        <!-- Portfolio Modals--><!-- Modal 1-->
        <div class="portfolio-modal modal fade" id="portfolioModal1" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-modal" data-dismiss="modal"><img src="assets/img/close-icon.svg" alt="Close modal" /></div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8">
                                <div class="modal-body">
                                    <!-- Project Details Go Here-->
                                    <h2 class="text-uppercase">Project Name</h2>
                                    <p class="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                                    <img class="img-fluid d-block mx-auto" src="assets/img/portfolio/01-full.jpg" alt="" />
                                    <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                                    <ul class="list-inline">
                                        <li>Date: January 2020</li>
                                        <li>Client: Threads</li>
                                        <li>Category: Illustration</li>
                                    </ul>
                                    <button class="btn btn-primary" data-dismiss="modal" type="button"><i class="fas fa-times mr-1"></i>Close Project</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal 2-->
        <div class="portfolio-modal modal fade" id="portfolioModal2" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-modal" data-dismiss="modal"><img src="assets/img/close-icon.svg" alt="Close modal" /></div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8">
                                <div class="modal-body">
                                    <!-- Project Details Go Here-->
                                    <h2 class="text-uppercase">Project Name</h2>
                                    <p class="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                                    <img class="img-fluid d-block mx-auto" src="assets/img/portfolio/02-full.jpg" alt="" />
                                    <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                                    <ul class="list-inline">
                                        <li>Date: January 2020</li>
                                        <li>Client: Explore</li>
                                        <li>Category: Graphic Design</li>
                                    </ul>
                                    <button class="btn btn-primary" data-dismiss="modal" type="button"><i class="fas fa-times mr-1"></i>Close Project</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal 3-->
        <div class="portfolio-modal modal fade" id="portfolioModal3" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-modal" data-dismiss="modal"><img src="assets/img/close-icon.svg" alt="Close modal" /></div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8">
                                <div class="modal-body">
                                    <!-- Project Details Go Here-->
                                    <h2 class="text-uppercase">Project Name</h2>
                                    <p class="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                                    <img class="img-fluid d-block mx-auto" src="assets/img/portfolio/03-full.jpg" alt="" />
                                    <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                                    <ul class="list-inline">
                                        <li>Date: January 2020</li>
                                        <li>Client: Finish</li>
                                        <li>Category: Identity</li>
                                    </ul>
                                    <button class="btn btn-primary" data-dismiss="modal" type="button"><i class="fas fa-times mr-1"></i>Close Project</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal 4-->
        <div class="portfolio-modal modal fade" id="portfolioModal4" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-modal" data-dismiss="modal"><img src="assets/img/close-icon.svg" alt="Close modal" /></div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8">
                                <div class="modal-body">
                                    <!-- Project Details Go Here-->
                                    <h2 class="text-uppercase">Project Name</h2>
                                    <p class="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                                    <img class="img-fluid d-block mx-auto" src="assets/img/portfolio/04-full.jpg" alt="" />
                                    <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                                    <ul class="list-inline">
                                        <li>Date: January 2020</li>
                                        <li>Client: Lines</li>
                                        <li>Category: Branding</li>
                                    </ul>
                                    <button class="btn btn-primary" data-dismiss="modal" type="button"><i class="fas fa-times mr-1"></i>Close Project</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal 5-->
        <div class="portfolio-modal modal fade" id="portfolioModal5" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-modal" data-dismiss="modal"><img src="assets/img/close-icon.svg" alt="Close modal" /></div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8">
                                <div class="modal-body">
                                    <!-- Project Details Go Here-->
                                    <h2 class="text-uppercase">Project Name</h2>
                                    <p class="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                                    <img class="img-fluid d-block mx-auto" src="assets/img/portfolio/05-full.jpg" alt="" />
                                    <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                                    <ul class="list-inline">
                                        <li>Date: January 2020</li>
                                        <li>Client: Southwest</li>
                                        <li>Category: Website Design</li>
                                    </ul>
                                    <button class="btn btn-primary" data-dismiss="modal" type="button"><i class="fas fa-times mr-1"></i>Close Project</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal 6-->
        <div class="portfolio-modal modal fade" id="portfolioModal6" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-modal" data-dismiss="modal"><img src="assets/img/close-icon.svg" alt="Close modal" /></div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8">
                                <div class="modal-body">
                                    <!-- Project Details Go Here-->
                                    <h2 class="text-uppercase">Project Name</h2>
                                    <p class="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                                    <img class="img-fluid d-block mx-auto" src="assets/img/portfolio/06-full.jpg" alt="" />
                                    <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                                    <ul class="list-inline">
                                        <li>Date: January 2020</li>
                                        <li>Client: Window</li>
                                        <li>Category: Photography</li>
                                    </ul>
                                    <button class="btn btn-primary" data-dismiss="modal" type="button"><i class="fas fa-times mr-1"></i>Close Project</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import router from '@/plugins/router'
    import {
        getProcessedAuthResponseErrorsFlat,
        logout
    } from '@/scripts/auth-utils'
    import optionalAuthView from '@/mixins/optional-auth-view'
    import {onSubmitHandler} from '@/scripts/forms-utils'
    import gql from 'graphql-tag'
    import FormErrors from '@/components/FormErrors'

    export default {
        components: {FormErrors},
        mixins: [optionalAuthView],
        data() {
            return {
                signUpUrl: router.resolve({name: 'pre-registration'}).href,
                loginUrl: router.resolve({name: 'login'}).href,
                portalUrl: router.resolve({name: 'feed'}).href,
                termsOfUseUrl: router.resolve({name: 'terms-of-use'}).href,
                privacyPolicyUrl: router.resolve({name: 'privacy-policy'}).href,
                errors: [],
                graphqlLoadingFlag: false,
                contactUsForm: {
                    email: '',
                    name: '',
                    occupation: '',
                    message: '',
                    source: 'RoweronMainPage'
                },
                contactUsEmailWasSent: false
            }
        },
        methods: {
            logout() {
                logout()
            },
            goToSignUpUrl() {
                router.push({name: 'pre-registration'})
            },
            async onSubmit() {
                let mutation = gql`
                        mutation contactUsRequest ($email: String!, $name: String!, $occupation: String!, $message: String!, $source: String!) {
                          contactUsRequest(email: $email, name: $name, occupation: $occupation, message: $message, source: $source){
                            success,
                            errors
                        }
                    }
                `

                await onSubmitHandler(this, mutation,
                    {
                        setErrorsF: (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors),
                        onSuccessF: (res, scope) => scope.contactUsEmailWasSent = true,
                        onStartF: (scope) => scope.contactUsEmailWasSent = false,
                        mutationVariables: this.contactUsForm
                    })
            }
        },
        mounted() {
            let script1 = document.createElement('script')
            script1.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js')

            let script2 = document.createElement('script')
            script2.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js')

            let script3 = document.createElement('script')
            script3.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/js/bootstrap.bundle.min.js')

            let script4 = document.createElement('script')
            script4.setAttribute('src', '/static_main/scripts.js')

            script1.onload = () => {
                script2.onload = () => {
                    script3.onload = () => {
                        document.head.appendChild(script4)
                    }
                    document.head.appendChild(script3)
                }
                document.head.appendChild(script2)
            }
            document.head.appendChild(script1)
        },
    }
</script>
<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s .7S
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .portal-button-text:hover {
        color: #fff !important;
    }
</style>
